var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99416 1.16675C3.77416 1.16675 1.16666 3.78008 1.16666 7.00008C1.16666 10.2201 3.77416 12.8334 6.99416 12.8334C10.22 12.8334 12.8333 10.2201 12.8333 7.00008C12.8333 3.78008 10.22 1.16675 6.99416 1.16675ZM6.99999 11.6667C4.42166 11.6667 2.33332 9.57841 2.33332 7.00008C2.33332 4.42175 4.42166 2.33341 6.99999 2.33341C9.57832 2.33341 11.6667 4.42175 11.6667 7.00008C11.6667 9.57841 9.57832 11.6667 6.99999 11.6667ZM7.29166 4.08342H6.41666V7.58342L9.47916 9.42091L9.91666 8.70342L7.29166 7.14592V4.08342Z",
    fill: "#37288E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99416 1.16675C3.77416 1.16675 1.16666 3.78008 1.16666 7.00008C1.16666 10.2201 3.77416 12.8334 6.99416 12.8334C10.22 12.8334 12.8333 10.2201 12.8333 7.00008C12.8333 3.78008 10.22 1.16675 6.99416 1.16675ZM6.99999 11.6667C4.42166 11.6667 2.33332 9.57841 2.33332 7.00008C2.33332 4.42175 4.42166 2.33341 6.99999 2.33341C9.57832 2.33341 11.6667 4.42175 11.6667 7.00008C11.6667 9.57841 9.57832 11.6667 6.99999 11.6667ZM7.29166 4.08342H6.41666V7.58342L9.47916 9.42091L9.91666 8.70342L7.29166 7.14592V4.08342Z",
    fill: "#37288E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.36781215.svg";
export { ForwardRef as ReactComponent };